 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML03_EPIGRAPH from '@/components/xhtml/03_Epigraph'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_IMAGE from '@/components/xhtml/05_Image'
 import XHTML06_1__FIRST from '@/components/xhtml/06_1__First'
 import XHTML07_2__PROBI from '@/components/xhtml/07_2__Probi'
 import XHTML08_3__ARAB from '@/components/xhtml/08_3__Arab'
 import XHTML09_4__RACHE from '@/components/xhtml/09_4__Rache'
 import XHTML10_5__THE_L from '@/components/xhtml/10_5__The_L'
 import XHTML11_6__THE_T from '@/components/xhtml/11_6__The_T'
 import XHTML12_7__BARBA from '@/components/xhtml/12_7__Barba'
 import XHTML13_8__GENTL from '@/components/xhtml/13_8__Gentl'
 import XHTML14_9__ISRAE from '@/components/xhtml/14_9__Israe'
 import XHTML15_10__FREE from '@/components/xhtml/15_10__Free'
 import XHTML16_11__THE from '@/components/xhtml/16_11__The'
 import XHTML17_12__THE from '@/components/xhtml/17_12__The'
 import XHTML18_13__STEP from '@/components/xhtml/18_13__Step'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML19_AFTERWOR from '@/components/xhtml/19_Afterwor'
 import XHTML20_INDEX from '@/components/xhtml/20_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Image",
 			"name" : "xhtml/05_Image",
 			"component" : XHTML05_IMAGE
 		},
 		{
 			"path" : "/xhtml/06_1__First",
 			"name" : "xhtml/06_1__First",
 			"component" : XHTML06_1__FIRST
 		},
 		{
 			"path" : "/xhtml/07_2__Probi",
 			"name" : "xhtml/07_2__Probi",
 			"component" : XHTML07_2__PROBI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js